"use strict";

import angular from "angular";

export class NucontentModelEmailCtrl {
    constructor($stateParams, $mdDialog, locals, $state) {
        this.$stateParams = $stateParams;
        this.$mdDialog = $mdDialog;
        this.locals = locals;
    }

    $onInit() {}
}

angular.module("nucont.shared").controller("NucontentModelEmailCtrl", [
        "$stateParams",
        "$mdDialog",
        "locals",

        NucontentModelEmailCtrl
    ]);
